import { dispatch } from './events';
import {
  SECTION_SIGNUP,
  DISPATCH_EVENT,
  SECTION_SWITCH,
  SECTION_LOGIN,
} from '../components/RegistrationModal/constants';

export function openSignup(trigger, overrides = null) {
  dispatch(DISPATCH_EVENT, {
    trigger,
    section: SECTION_SIGNUP,
    ...overrides,
  });
}
export function openLogin(trigger, email = null) {
  dispatch(DISPATCH_EVENT, {
    trigger,
    section: email === null ? SECTION_SWITCH : SECTION_LOGIN,
    email,
  });
}
export function openSwitchAccounts(trigger) {
  dispatch(DISPATCH_EVENT, {
    trigger,
    section: SECTION_SWITCH,
  });
}
